<template>
    <div>
        <van-nav-bar :title="title">
            <template #left>
                <img v-show="language == 'zh'" @click="toggleLanguage('zh')" src="~statics/mobileShouye/cn-change.png" alt="" style="width: .44rem; height: .44rem">
                <img v-show="language == 'en'" @click="toggleLanguage('en')" src="~statics/mobileShouye/en-change.png" alt="" style="width: .44rem; height: .44rem">
            </template>
            <template #right>
                <span @click="goBack" class="cancel">{{$t('detail').uncollect}}</span>
            </template>
        </van-nav-bar>
    </div>
</template>

<script>
import { changeLanuage } from "@/lang";
import { mapState } from "vuex";

export default {
    props:{
        title: {
            default: '',
            type: String
        }
    },
    data(){
        return{
            language:  null,
        }
    },
    created() {
        this.language = localStorage.getItem("language") || "zh";
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        toggleLanguage(type) {
            if (type == 'zh'){
                this.language = 'en';
                changeLanuage(this.language);
            };
            if(type == 'en'){
                this.language = 'zh';
                changeLanuage(this.language);
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.cancel{
    line-height: .38rem;
    color: #fff;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileSearch/components/searchFooters.vue